export default "__VITE_ASSET__941e46df__"